<script setup lang="ts">
import useCityStore from '~/store/city'
import useUserStore from '~/store/user'
import { getChargemapUrl } from '~/utils/url'
import ChargemapB2CPagination from '~/components/Common/ChargemapB2CPagination.vue'

const LEGACY_URL = useRuntimeConfig().public.LEGACY_URL as string
const { locale } = useI18n()
const cityStore = useCityStore()
const userStore = useUserStore()

const props = defineProps({
    nbOfPoolsToFetch: {
        type: Number,
        required: true
    }
})

const canLoadMore = computed(
    () =>
        props.nbOfPoolsToFetch * (cityStore.pageIndex - 1) <
            cityStore.totalPools &&
        cityStore.totalPools > props.nbOfPoolsToFetch
)
</script>

<template>
    <div class="flex flex-col justify-center items-center gap-6 px-4">
        <div
            v-if="cityStore.poolsLoading && cityStore.pools.length === 0"
            class="grid grid-cols-1 md:grid-cols-3 gap-2"
        >
            <ChargemapSkeletonLoader
                v-for="i in 9"
                :key="`skeleton-${i}`"
                class="max-w-[327px] h-[200px]"
            />
        </div>
        <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-2">
            <MappyPoolPreview
                v-for="pool in cityStore.pools.slice(0, 2)"
                :key="`pool-preview-${pool.id}`"
                :pool
                :loading-stations="false"
                :chargemap-url="getChargemapUrl('', locale)"
                :is-b2-b="false"
                :legacy-api-url="LEGACY_URL"
            />
            <a
                v-if="!userStore.userAlreadyHasAPass"
                href="/pass"
                :title="$t('more.learn_more')"
            >
                <DiscoverChargemapPass
                    id="discover-chargemap-pass"
                    :compatible="false"
                    drawer
                />
            </a>
            <MappyPoolPreview
                v-for="pool in cityStore.pools.slice(2, nbOfPoolsToFetch)"
                :key="`pool-preview-${pool.id}`"
                class="pool-preview"
                :pool
                :loading-stations="false"
                :chargemap-url="getChargemapUrl('', locale)"
                :is-b2-b="false"
                :legacy-api-url="LEGACY_URL"
            />
        </div>
        <ChargemapB2CPagination
            v-if="canLoadMore"
            :current-index="cityStore.pageIndex"
            :per-page="nbOfPoolsToFetch"
            :total="cityStore.totalPools"
            :paginated-url="`/cities/${cityStore.slug}-${cityStore.countryCode}/{page}`"
        />
    </div>
</template>

<style lang="scss" scoped>
#discover-chargemap-pass {
    @apply max-w-[327px] w-full h-full text-[17px] #{!important};
}

.pool-preview > :first-child > :first-child {
    @apply justify-between h-full #{!important};
}
</style>
